<template>
  <section>
    <AboutMembersHeader />
    <AboutMembersIntro />
    <AboutMembersIndex v-for="(group, i) in groups" :key="group.title" :group="group" :is-first="!i" />
    <!-- <AboutMembersIndex2 />
    <AboutMembersIndex3 />
    <AboutMembersIndex4 /> -->
    <AboutMembersMore />
    <AboutMembersCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'AboutMembers',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-members'] || {}
    }
  },
  computed: {
    groups() {
      return this.$wp.pages['about-members'].groups || []
    }
  },
  mounted() {
    console.log('about-members', this.$wp.pages['about-members'])
  }
}
</script>
